export function replaceAt(originalString, index, replaceChar) {
    return (
        originalString.substring(0, index) +
        replaceChar +
        originalString.substring(index + 1)
    );
}